import React from "react";
import MediaQuery from "../MediaQuery";
import OptimizedImage from "../OptimizedImage";
import RichText from "../RichText";

import {
  Container,
  ContentContainer,
  Headline,
  HeadlineContainer,
  IconContainer,
  Illustration,
} from "./ValuePropositionCard.styles";

export interface ValuePropositionCardProps {
  $isActive: boolean;
  card: Queries.Maybe<Queries.SanityValuePropositionCardItem>;
  onClick?: () => void;
}

const ValuePropositionCard: React.FC<ValuePropositionCardProps> = ({
  card,
  $isActive,
  onClick,
}) => (
  <Container $isActive={$isActive} onClick={onClick}>
    <ContentContainer>
      <HeadlineContainer>
        {card?.icon && (
          <IconContainer>
            <OptimizedImage image={card.icon} alt={card.iconAlt} />
          </IconContainer>
        )}

        <Headline $showMagicText={card?.giveTextMagicColor as boolean}>
          {card?.headline}
        </Headline>
      </HeadlineContainer>

      {card?._rawCardDescription && (
        <RichText text={card._rawCardDescription} variant="B3" />
      )}
    </ContentContainer>

    <MediaQuery $lessThan="medium">
      {card?.imageMobile && (
        <Illustration>
          <OptimizedImage image={card.imageMobile} alt={card.imagesAlt} />
        </Illustration>
      )}
    </MediaQuery>

    <MediaQuery $between={["medium", "large"]}>
      {card?.imageTablet && (
        <Illustration>
          <OptimizedImage image={card.imageTablet} alt={card.imagesAlt} />
        </Illustration>
      )}
    </MediaQuery>
  </Container>
);

export default ValuePropositionCard;
